<i18n>
  {
    "fr": {
      "title": "Conformité générale",
      "text": "Le suivi des tâches en cours est essentiel pour garantir la conformité et améliorer les performances.",
      "link": "Consulter les tâches à faire"
    },
    "en": {
      "title": "General compliance",
      "text": "Tracking ongoing tasks is essential to ensure compliance and improve performance.",
      "link": "View tasks to do"
    }
  }
</i18n>

<template>
  <compliance-chart
    :title="$t('title')"
    :text="$t('text')"
    :link="tasksLink"
    :done-count="data.doneCount"
    :in-progress-count="data.inProgressCount"
    :todo-count="data.todoCount"
    :not-applicable-count="data.notApplicableCount"
  />
</template>

<script>
import ComplianceChart from './compliance-chart'

export default {
  components: { ComplianceChart },
  props: {
    data: { type: Object, required: true }
  },
  computed: {
    tasksLink() {
      return { text: this.$t('link'), name: this.$consts.urls.URL_PENDING_TASKS, query: { tab: 'general' } }
    }
  }
}
</script>

<fragments>
fragment generalComplianceChart on IndicatorsProgressStatsGraphType {
  doneCount
  inProgressCount
  notApplicableCount
  todoCount
}
</fragments>